export function smoothScroll() {
	document.addEventListener('click', (e) => {
		const link = e.target.closest('a[href*="#"]');
		if (!link) return;

		const href = link.getAttribute('href');
		if (href === '#') return;

		// Extract the hash part
		let hash;
		try {
			const url = new URL(href, window.location.origin);
			// Only handle if same page or homepage anchor
			if (url.origin !== window.location.origin) return;
			if (url.pathname !== '/' && url.pathname !== window.location.pathname) return;
			hash = url.hash;
		} catch {
			hash = href.startsWith('#') ? href : null;
		}

		if (!hash) return;

		const target = document.querySelector(hash);
		if (!target) return;

		e.preventDefault();
		target.scrollIntoView({ behavior: 'smooth' });
	});
}
